import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { toast } from 'react-toastify'
import APIS from '../../constant/EndPoint'
import { useSearchParams } from 'react-router-dom'
import usePDFPrintHook from '../../customHooks/usePDFPrintHook'

export default function PrintActionMenu(props: any) {
  const [searchParams, setSearchParms] = useSearchParams()
  const { mutateAsync: downloadPrint, isPostLoading: isPrintLoading } = usePDFPrintHook({
    queryKey: [],
  });

  const handleLabelPrintDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first")
      return
    }
    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: selectedOrder
    };
    try {
      const res = await downloadPrint({url, formData});
      const fileURL = URL.createObjectURL(res?.data);
      window.open(fileURL);
    } catch (err) {
      console.log(err);
    }
  }

  const handleOrderReceiptDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first")
      return
    }
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: selectedOrder
    };
    try {
      const res = await downloadPrint({url, formData});
      const fileURL = URL.createObjectURL(res?.data);
      window.open(fileURL);
    } catch (err) {
      console.log(err);
    }
  }

  const handlePODReceiptDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first")
      return
    }
    const url = `${APIS.ORDER}order-pod-print/`;
    let formData = {
      order_ids: selectedOrder
    };
    try {
      const res = await downloadPrint({url, formData});
      const fileURL = URL.createObjectURL(res?.data);
      window.open(fileURL);
    } catch (err) {
      console.log(err);
    }
  }
  const handleButtonClick = (type: string) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first")
      return
    }
  }
  return (
    <div className=" top-16 text-right">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex w-full justify-center rounded-md text-primary px-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            Print
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute mt-2 w-40 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={handleLabelPrintDownload}
                    className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    Label Print
                  </button>
                )}
              </Menu.Item>
            </div>
            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleButtonClick("Return")}
                    className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    Return Print
                  </button>
                )}
              </Menu.Item>
            </div>
            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleOrderReceiptDownload()}
                    className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    Order Receipt
                  </button>
                )}
              </Menu.Item>
            </div>
            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handlePODReceiptDownload()}
                    className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    POD Receipt
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}
